<template>
  <section class="layouts-container"
           :style="{
      backgroundColor: webInfo.bgColor,
      backgroundImage: `url(${webInfo.bgImage})`
    }">
    <!-- 非选择元素模式 -->
    <template v-if="!isCheckMode">
      <!-- edit模式 -->
      <template v-if="isEditMode">
        <draggable group="modules"
                   class="drag-wrapper"
                   animation="200"
                   :disabled="!isEditMode || !drag"
                   ghostClass="ghost"
                   filter=".forbid"
                   chosenClass="chosen"
                   :forceFallback="true"
                   v-model="modulesList"
                   @start="start"
                   @end="end"
                   @add="add">
          <template v-if="modulesList.length > 0">
            <div class="module-item"
                 v-for="(item, index) in modulesList"
                 v-show="isEditMode ? true : item.visible"
                 :style="{ width: item.name === 'picture' ? item.width + '%' : '100%' }"
                 :key="index">
              <div class="id-status"
                   v-if="showEgg">
                {{ item.id }}<br />{{ item.picName || '' }}
              </div>
              <!-- 状态指示图标 -->
              <div class="status-list"
                   v-if="currentBindModules">
                <div class="item parent"
                     v-if="currentBindModules.includes(item.id)">
                  <icon src="gsm-link-m"></icon>
                </div>
                <div class="item hide"
                     v-if="
                    currentBindModules.includes(item.id) &&
                    !currentModule.defaultShow
                  ">
                  <icon src="gsm-eye-off-line"></icon>
                </div>
              </div>
              <component v-on:disableDrag="disableDrag"
                         v-on:enableDrag="enableDrag"
                         :info="item"
                         :isEditMode="isEditMode"
                         @click.native="checkThis(index, $event)"
                         :is="item.name + 'Layout'"
                         :class="{
                  checked: currentModuleIndex === index && !focusItem
                }"></component>
            </div>
          </template>
          <template v-else>
            <el-empty class="forbid"
                      description="试着拖动左侧组件到这里"></el-empty>
          </template>
        </draggable>
      </template>
      <template v-else>
        <!-- 非edit模式 -->
        <!-- 闪屏图 -->
        <section class="launch-container flex-c"
                 v-if="launchScreen.enable && showLaunch"
                 :style="{
            backgroundImage: `url(${
              launchScreen.src +
              '&imageMogr2/thumbnail/2000x2000/format/' +
              `${
                launchScreen.src.toLowerCase().indexOf('gif') < 0
                  ? $pic_type
                  : 'gif'
              }` +
              '/interlace/1'
            })`
          }">
          <div class="time-wrapper">
            <span class="time">{{ time }}</span>s
          </div>

          <div class="enter-wrapper"
               @click="enter"
               v-if="launchScreen.hasSkip">
            {{ launchScreen.skipText }}
            <icon class="icon"
                  src="gsm-arrow-right-s-line"></icon>
          </div>
        </section>
        <template v-if="modulesList.length > 0">
          <div class="module-item"
               v-for="(item, index) in modulesList"
               v-show="item.visible"
               :style="{ width: item.name === 'picture' ? item.width + '%' : '100%' }"
               :key="index">
            <component :info="item"
                       :isEditMode="false"
                       @click.native="checkThis(index, $event)"
                       :is="item.name + 'Layout'"></component>
          </div>
        </template>
        <template v-else>
          <el-empty class="forbid"
                    description="这里空空如也"></el-empty>
        </template>
      </template>
    </template>

    <!-- 选择元素模式 -->
    <template v-else>
      <template v-if="modulesList.length > 0">
        <div class="check-wrapper"
             v-for="(item, index) in modulesList"
             :key="index"
             :style="{ width: item.width + '%' }">
          <div class="check-mask"
               @click.stop="checkElement(item.id, index)">
            <div class="current-cover"
                 v-if="index === currentModuleIndex">
              <p>当前元素（不可选）</p>
              <p class="tips">单击选择其他元素</p>
            </div>
            <div class="cover"
                 v-if="checkElementList.includes(item.id)">
              <div class="icon">
                <icon src="gsm-check-fill"></icon>
              </div>
            </div>
          </div>
          <component :info="item"
                     @click.native="checkThis(index, $event)"
                     :is="item.name + 'Layout'"
                     :class="{
              checked: currentModuleIndex === index && isEditMode && !focusItem
            }"></component>
        </div>
      </template>
    </template>
  </section>
</template>
<script>
import TextLayout from '@/components/XModules/Text/Layout.vue'
import PictureLayout from '@/components/XModules/Picture/Layout.vue'
import VideoLayout from '@/components/XModules/Video/Layout.vue'
import SwipeLayout from '@/components/XModules/Swipe/Layout.vue'
import HtmlLayout from '@/components/XModules/Html/Layout.vue'
import JsLayout from '@/components/XModules/Js/Layout.vue'
import Draggable from 'vuedraggable'
export default {
  /******************************************
   ** 布局组件集
   * @description 布局组件集
   * @author stone
   *****************************************
   isEditMode         Boolean        编辑器模式（默认false）
   *****************************************/
  name: 'layoutsContainer',
  components: {
    TextLayout,
    PictureLayout,
    VideoLayout,
    SwipeLayout,
    HtmlLayout,
    JsLayout,
    Draggable
  },
  props: {
    isEditMode: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      drag: true,
      focusItem: false,
      showLaunch: true,
      time: 0,
      showEgg: false
    }
  },
  watch: {},
  computed: {
    webInfo () {
      return this.$store.state.page.webInfo
    },
    launchScreen () {
      return this.$store.state.page.launchScreen
    },
    checkElementList () {
      return this.$store.state.page.checkElementList
    },
    currentBindModules () {
      return this.currentModule ? this.currentModule.bindModules : []
    },
    isCheckMode () {
      return this.$store.state.page.checkMode
    },
    currentModule () {
      return this.modulesList[this.currentModuleIndex]
    },
    modulesList: {
      get: function () {
        return this.$store.state.page.moduleList
      },
      set: function (e) {
        this.$store.commit('SET_MODULE_LIST', e)
      }
    },
    currentModuleIndex () {
      return this.$store.state.page.currentModuleIndex
    }
  },
  methods: {
    checkThis (index, e) {
      if (this.isEditMode) {
        e.stopPropagation()
      }
      this.$store.state.page.currentModuleIndex = index
      if (!this.isCheckMode && !this.isEditMode) {
        const arr = this.modulesList[index]
          ? this.modulesList[index].bindModules
          : []
        if (arr && arr.length > 0) {
          // 存在绑定点击事件的元素
          arr.map((id) => {
            if (this.getModuleById(id)) {
              this.getModuleById(id).visible = !this.getModuleById(id).visible
            }
          })
        }
      }
    },
    getModuleById (id) {
      const obj = this.modulesList.filter((item) => {
        return item.id === id
      })
      return obj[0]
    },
    checkElement (id, index) {
      if (index !== this.currentModuleIndex) {
        if (!this.checkElementList.includes(id)) {
          this.checkElementList.push(id)
        } else {
          this.checkElementList.splice(this.checkElementList.indexOf(id), 1)
        }
      }
    },
    disableDrag () {
      this.drag = false
    },
    enableDrag () {
      this.drag = true
    },
    start (e) {
      this.focusItem = true
    },
    end (e) {
      this.focusItem = false
      this.$store.state.page.currentModuleIndex = e.newIndex
    },
    add (e) {
      this.$store.state.page.currentModuleIndex = e.newIndex
    },
    enter () {
      this.showLaunch = false
    },
    startLaunch () {
      this.time = this.launchScreen.delay
      // 进入倒计时
      const interval = setInterval(() => {
        if (this.time > 1) {
          this.time--
        } else {
          // 倒计时结束
          this.showLaunch = false
          this.time = this.launchScreen.delay
          window.clearInterval(interval)
        }
      }, 1000)
    }
  },
  mounted () {
    this.modulesList = []
  }
}
</script>
<style lang="scss" scoped>
.layouts-container {
  box-sizing: border-box;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  min-height: 100%;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;

  .launch-container {
    width: 100%;
    height: 100%;
    min-height: 100%;
    background-color: #fff;
    top: 0;
    left: 0;
    z-index: 1000;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    .time-wrapper {
      position: absolute;
      right: 15px;
      top: 15px;
      width: 15px;
      display: flex;
      justify-content: center;
      padding: 5px 15px;
      backdrop-filter: saturate(180%) blur(10px);
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 14px;
    }

    .enter-wrapper {
      background: rgba(255, 255, 255, 0.85);
      padding: 14px 35px 14px 55px;
      border-radius: 5px;
      font-size: 14px;
      position: absolute;
      bottom: 40px;
      color: #222;
      display: flex;
      align-items: center;
      // backdrop-filter: saturate(180%) blur(5px);

      .icon {
        margin-left: 2px;
        font-size: 20px;
      }
    }
  }
  .drag-wrapper {
    min-height: 600px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: flex-start;
    width: 100%;
  }
  .el-empty {
    min-height: 600px;
    width: 100%;
  }

  .module-item {
    position: relative;
    width: 100%;

    .id-status {
      position: absolute;
      left: -200px;
      width: 200px;
      height: 100%;
      top: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      border-bottom: 1px solid #dcdfe6;
      color: #bcbcbc;
    }
    .status-list {
      height: 30px;
      position: absolute;
      top: 50%;
      margin-left: 10px;
      margin-top: -15px;
      left: 100%;
      display: flex;
      justify-content: flex-start;
      z-index: 11;

      .item {
        margin-right: 3px;
        height: 30px;
        padding: 0 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 20px;
        border-radius: 4px;
      }
    }
  }

  .checked {
    border: 1px dashed #1c28b5;
    box-sizing: border-box;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 48%;
      left: -20px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: red;
    }
  }

  .chosen {
    background: #f8fafc;
    color: #333;
    border: 1px dashed #1c28b5;
    box-sizing: border-box;
  }

  .ghost {
    background: #f8fafc;
  }

  .check-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: flex-start;
    width: 100%;

    .check-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10;

      .current-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        background: #e6e6e6;
        font-size: 14px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        p {
          line-height: 25px;
        }

        .tips {
          color: #666;
          font-size: 12px;
        }
      }

      &:hover {
        cursor: pointer;
      }

      .cover {
        position: absolute;
        top: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        left: 0;
        width: 100%;
        min-height: 100%;
        color: #2354f2;
        font-size: 20px;
        border: 3px solid rgba(255, 255, 255, 0.7);
        box-sizing: border-box;
        background-color: rgba(0, 60, 255, 0.7);
        background-image: url("https://assets.aiyaopai.com/xiewen.png");
        background-repeat: repeat;
        background-size: 50%;
      }

      .icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .checked {
        background: #2354f2;
        height: 30px;
        width: 30px;
        justify-content: center;
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #fff;
        box-sizing: border-box;
        position: absolute;
        left: 0px;
        top: 0px;
      }
    }
  }
}
</style>
